import React from "react";
import { useTranslation } from "react-i18next";
import "./Profile.css";
import { useLocation, useNavigate } from "react-router-dom";
import PersonalInfo from "./PersonalInfo";
import Preferences from "./Preferences";
import Password from "./Password";
import PermissionsTable from "../../components/PermissionsTable/PermissionsTable";
import { getPermissionDisplayData, getUserRole, USER_ROLES } from "../../utils/UsersPermissions";


const ProfilePage = ({ path, profile }) => {
  const { t, i18n } = useTranslation("profile");
  const navigate = useNavigate();
  const location = useLocation();
 // Get permissions based on user role
  const permissions = getPermissionDisplayData(t);
  const userRole = getUserRole();
  const showPermissionsTab = userRole === USER_ROLES.VIEWER || userRole === USER_ROLES.MANAGER;

  const handleNavigateWithParams = (path) => {
    navigate({
      pathname: location.pathname,
      search: `?path=${path}`, // Add your desired query params
    });
  };

  const getTitle = () => {
    if (location.pathname === "/settings") {
      return t("settings");
    } else if (location.pathname === "/profile") {
      return t("profile");
    } else {
      return t("titleDefault");
    }
  };

  return (
    <div className={"ProfilePage"}>
      <div className={"Header"}>
        <h3>{getTitle()}</h3>
        <div className={"HeaderNav"}>
          <p
            onClick={() => handleNavigateWithParams("profile")}
            style={
              !path || path === "profile" || path === "editProfile"
                ? { borderBottom: "4px solid #5507CF" }
                : { opacity: "0.6" }
            }
          >
            {t("tabPersonalInfo")}
          </p>
          <p
            onClick={() => handleNavigateWithParams("password")}
            style={
              path === "password"
                ? { borderBottom: "4px solid #5507CF" }
                : { opacity: "0.6" }
            }
          >
            {t("tabPassword")}
          </p>
          <p
            onClick={() => handleNavigateWithParams("preferences")}
            style={
              path === "preferences"
                ? { borderBottom: "4px solid #5507CF" }
                : { opacity: "0.6" }
            }
          >
            {t("tabPreferences")}
          </p>
          {showPermissionsTab && (
            <p
              onClick={() => handleNavigateWithParams("permissions")}
              style={
                path === "permissions"
                  ? { borderBottom: "4px solid #5507CF" }
                  : { opacity: "0.6" }
              }
            >
              {t("tabPermissions")}
            </p>
          )}
        </div>
      </div>
      {!path || path === "profile" || path === "editProfile" ? (
        <PersonalInfo profile={profile} edit={path === "editProfile"} />
      ) : path === "preferences" ? (
        <Preferences />
      ): path === "permissions" && showPermissionsTab ? (
        <PermissionsTable permissions={permissions} />
      ) : (
        <Password />
      )}
    </div>
  );
};

export default ProfilePage;
